import { render, staticRenderFns } from "./propety.vue?vue&type=template&id=6b0b0d2d&scoped=true&"
import script from "./propety.vue?vue&type=script&lang=js&"
export * from "./propety.vue?vue&type=script&lang=js&"
import style0 from "./propety.vue?vue&type=style&index=0&id=6b0b0d2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0b0d2d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
